import React from 'react'

const Textos = ({ semestre }) => {
  switch (semestre) {
    case '2016-1':
      return (
        <>
          <p>
            Fueron 18 las causas en que el gobierno decidió hacerse parte a
            través de acciones legales, por hechos ocurridos en la Región de La
            Araucanía. Una de estas corresponde al atentado a un templo
            religioso, ocurrido en <strong>Pidima</strong>. Durante este año, en
            total, se registraron 19 atentados a recintos de oración, de los
            cuales 12 correspondieron a capillas católicas y nueve a templos
            evangélicos.
          </p>
          <p>
            Un porcentaje importante de estos atentados fue atribuido por la
            agrupación <strong>Weichán Auka Mapu</strong>. La causa por la cual
            se querelló el Ejecutivo se encuentra cerrada y sin detenidos.
          </p>
          <p>
            Pese a la intensidad con que se atacaron recintos religiosos, las
            empresas forestales siguieron siendo atacadas y saboteadas. Según la
            <strong>Asociación de Contratistas Forestales</strong> ese año
            sufrieron 39 ataques, concentrados en la Provincia de Arauco, Región
            del Biobío.{' '}
          </p>
          <p>
            Las cifras de la <strong>Multigremial</strong> de La Araucanía
            también evidencian un año excepcionalmente violento.{' '}
          </p>
        </>
      )
      break
    case '2016-2':
      return (
        <>
          <p>
            Los ilícitos se concentraron en{' '}
            <strong>Ercilla y Collipulli</strong>, comunas que reunieron el 64%
            de los atentados por los cuales las Intendencias se querellaron. La
            mayor parte de los ataques ocurrieron en la Ruta 5 Sur o en sus
            inmediaciones.{' '}
          </p>

          <p>
            Al analizar las acciones legales del gobierno un dato salta a la
            vista: no existen detenidos ni formalizados en estas 18 causas, de
            las cuales 14 corresponden a incendios.{' '}
          </p>

          <p>
            Los escasos resultados, según gremios locales, dieron pie a la
            proliferación de nuevos ataques armados e incendiarios. La{' '}
            <strong>Asociación de Contratistas Forestales</strong> asegura que
            desde 2014 a la fecha, la fiscalía apenas logró dos condenas en las
            260 investigaciones por ataques a empresas y trabajadores del rubro.
            Un 0,77% de efectividad tras sus denuncias. Este año se registra un
            detenido que al día de hoy cumple condena tras las rejas.{' '}
          </p>
        </>
      )
      break
    case '2017-1':
      return (
        <>
          <p>
            Los delitos de incendio y robos con intimidación investigados en La
            Araucanía llevaron al gobierno a presentar 18 querellas. Con 19
            formalizados ese año, 2017 mostró los primeros resultados en las
            indagatorias más graves de violencia rural.
          </p>

          <p>
            Tras ello, los atentados mostraron una tendencia a la baja, según
            autoridades y gremios locales: sus cifras muestran que en el Biobío
            y la Araucanía hubo 12 ataques contra forestales.{' '}
          </p>

          <p>
            Al igual que el año anterior, los hechos más graves tuvieron cabida
            principalmente en las cercanías de la Ruta 5 Sur. Trece de las
            querellas que presentó el gobierno de Michelle Bachelet se
            vinculaban con <strong>ataques incendiarios</strong>.{' '}
          </p>

          <p>
            Las comunas más afectadas fueron{' '}
            <strong>Ercilla, Collipulli y Victoria</strong>, en la Región de La
            Araucanía.{' '}
          </p>
        </>
      )
      break

    case '2017-2':
      return (
        <>
          <p>
            Fue este año, además, en el marco de una investigación para
            identificar a los autores de hechos graves de violencia, que el 23
            de septiembre se realizó un operativo de Carabineros en el Biobío y
            la Araucanía que terminó con <strong>ocho comuneros mapuche</strong>{' '}
            detenidos.{' '}
          </p>

          <p>
            La operación fue bautizada como <strong>“Huracán”</strong>, la que
            posteriormente se derrumbaría por el uso de pruebas falsas para
            incriminar a los detenidos y terminó con altos oficiales de la
            policía encarcelados.{' '}
          </p>

          <p>
            Las zonas con comunidades en conflicto son puntos clave para las
            investigaciones policiales. Según Carabineros, solo en La Araucanía
            hay más de 3.200 comunidades étnicas, de las cuales cerca de 320
            mantendrían algún tipo de conflicto con el Estado, detalla el{' '}
            <strong>general Carlos González</strong>, jefe de la Macrozona Sur
            Control Orden Público.{' '}
          </p>

          <p>
            <a
              className="text-black underline"
              href="https://www.latercera.com/investigacion-y-datos/noticia/general-carlos-gonzalez-jefe-macrozona-sur-de-carabineros-aqui-el-congreso-nacional-tiene-una-responsabilidad/LVQMPFWKKNGIRBK4FDSA4KYYEY/"
              target="_blank"
              rel="noopener noreferrer">
              Leer entrevista al General Carlos González{' '}
            </a>
          </p>

          <p>
            Un total de cuatro personas detenidas este año se encuentran
            condenadas en régimen penitenciario cerrado.{' '}
          </p>
        </>
      )
      break

    case '2018-1':
      return (
        <>
          <p>
            La crisis que causó la <strong>Operación Huracán</strong> llevó a
            que Carabineros interviniera sus unidades de inteligencia y áreas
            investigativas en La Araucanía. Tras ello se enfocaron casi
            principalmente a la <strong>prevención en las rutas</strong> y
            cumplir alguna de las 487 medidas de protección a víctimas, vigentes
            hasta mayo.{' '}
          </p>

          <p>
            La consecuencia fue inmediata: la PDI asumió la mayor parte de las
            causas de violencia rural. Estadísticas del Ministerio Público
            muestran que, a la fecha, el{' '}
            <strong>64% de los casos los investiga la PDI</strong>, el 16%
            Carabineros y en un 20% se pidió diligencias a ambas policías.{' '}
          </p>
        </>
      )
      break

    case '2018-2':
      return (
        <>
          <p>
            Los registros de la PDI detallan que han detenido, desde 2018 hasta
            la fecha, a <strong>14 personas</strong> por incendios y atentados
            explosivos e incendiarios.{' '}
          </p>

          <p>
            Según la policía “es importante considerar que, dentro de los
            tópicos considerados como violencia rural, los imputados cometen
            otros delitos conexos como robo de vehículos, hurto de madera, porte
            y tenencia de armas, entre otros”.{' '}
          </p>

          <p>
            <a
              className="text-black underline"
              href="https://www.latercera.com/investigacion-y-datos/noticia/pdi-por-la-araucania-la-denominada-causa-politica-ha-sido-instrumentalizada-para-delinquir/43MDIZJMQFBTXPBO2P6Z7SR2CI/"
              target="_blank"
              rel="noopener noreferrer">
              Lee aquí la respuesta de la PDI{' '}
            </a>
          </p>
          <p>
            Durante 2018, <strong>solo nueve personas</strong> fueron
            formalizadas en causas donde el gobierno era querellante.
          </p>

          <p>
            A los escasos resultados, se sumó un episodio que cuestionó el
            actuar de Carabineros en la zona: el crimen del comunero mapuche{' '}
            <strong>Camilo Catrillanca</strong>, ocurrido el 14 de noviembre en
            la comunidad <strong>Temucuicui</strong>, en Ercilla.{' '}
          </p>

          <p>
            La investigación de la fiscalía estableció que un funcionario de
            Carabineros disparó sin provocación. El hecho{' '}
            <strong>agudizó la violencia</strong> en la zona. En apenas 47 días
            el gobierno se querelló por siete ataques graves ocurridos tras la
            muerte del comunero.{' '}
          </p>

          <p>
            El año 2018 registró <strong>cuatro detenidos</strong> que cumplen
            hasta el día de hoy una condena privativa de libertad.{' '}
          </p>
        </>
      )
      break

    case '2019-1':
      return (
        <>
          <p>
            Mientras los ataques aumentaban en frecuencia, los arrestos tenían
            un <strong>escaso avance</strong>. La PDI se defiende: "La ruralidad
            constituye el principal elemento que caracteriza los sitios de
            suceso de los delitos cometidos en ese contexto, dificultando el
            trabajo de las policías”
          </p>

          <p>
            Ese año, con la llegada de un nuevo alto mando en la PDI, surgió la
            “poda”, que en el ambiente policial -y de manera extraoficial- no es
            más que seguir de cerca a los sospechosos de atentados graves para
            detenerlos cuando cometen <strong>delitos comunes</strong>.{' '}
          </p>
          <p>
            "Estamos implementando nuevas fórmulas para mejorar la investigación
            de estos delitos, las cuales no se pueden detallar en lo
            específico", dicen en la PDI.
          </p>
        </>
      )
      break

    case '2019-2':
      return (
        <>
          <p>
            Del análisis de las acciones legales del Ejecutivo surge otro
            antecedente relevante: los nuevos <strong>“hotspots”</strong>, o
            puntos calientes donde ocurren atentados graves.{' '}
          </p>

          <p>
            Estas nuevas zonas muestran el desplazamiento de los grupos
            radicalizados desde las cercanías de la Ruta 5 Sur a{' '}
            <strong>caminos rurales</strong>
            distantes y boscosos.{' '}
          </p>

          <p>
            Así la <strong>ruta R-182</strong> y sus inmediaciones, que une
            Angol con Collipulli en La Araucanía, se convirtió en un “punto
            caliente”. Lo mismo ocurrió en sectores aledaños a la ruta{' '}
            <strong>P-72-S</strong> de la Provincia de Arauco, Región del
            Biobío.{' '}
          </p>

          <p>
            La violencia avanzó de tal forma que, el 16 de agosto de ese año,
            encapuchados quemaron una bodega instalada a menos de un kilómetro
            de un retén de Carabineros. <strong>No hubo detenidos</strong>.{' '}
          </p>

          <p>
            De acuerdo al barómetro de la{' '}
            <strong>Multigremial de La Araucanía</strong>, en 2018 los atentados
            subieron un 503%. El presidente de esta agrupación,{' '}
            <strong>Patricio Santibáñez</strong>, dice que detrás de los ataques
            hay “grupos paramilitares”.{' '}
          </p>

          <p>
            El número de querellas del gobierno llegó a <strong>144</strong> y
            los formalizados llegaron a <strong>36</strong>. Este año fueron
            detenidas seis personas que al día de hoy cumplen una condena en la
            cárcel, así como otros cuatro imputados que están en prisión
            preventiva.{' '}
          </p>
        </>
      )
      break

    case '2020-1':
      return (
        <>
          <p>
            Fue uno de los años más violentos. Solo en este periodo el gobierno
            presentó <strong>235 querellas</strong> por ataques graves en la
            zona.{' '}
          </p>

          <p>
            De ellas, <strong>101 acciones legales</strong> (43%) corresponden a
            quemas de casas y de maquinarias forestales. A tal punto escaló el
            conflicto que los ataques afectaron también las vías férreas que
            causaron el descarrilamiento de un tren de carga.{' '}
          </p>

          <p>
            El 2020, además, estuvo marcado por una{' '}
            <strong>huelga de hambre</strong> de comuneros mapuche que cumplían
            prisión preventiva en el penal de Angol, misma medida de presión que
            ejerció el machi <strong>Celestino Córdova</strong>, condenado en
            2014 por el homicidio del matrimonio Luchsinger Mackay. Su exigencia
            era asistir a su comunidad para realizar un ritual de renovación de
            su rewe.{' '}
          </p>
        </>
      )
      break

    case '2020-2':
      return (
        <>
          <p>
            El fiscal{' '}
            <strong>
              Héctor Leiva, jefe de Alta Complejidad de La Araucanía,
            </strong>
            asegura que entre los tantos factores que complejizan las
            indagatorias, “hay algún grado también de preparación de las
            personas que cometen estos delitos”.{' '}
          </p>

          <p>
            <a
              href="https://www.latercera.com/investigacion-y-datos/noticia/fiscal-jefe-de-alta-complejidad-de-la-araucania-tenemos-que-potenciar-el-analisis-criminal-que-permita-a-las-policias-anticiparse/XQ3STJ4I4NHALKLKGCUTS5QQMM/"
              target="_blank"
              rel="noopener noreferrer">
              Revisa la entrevista al Fiscal Leiva acá.{' '}
            </a>
          </p>

          <p>
            Según la Fiscalía de La Araucanía, este año se dejó a{' '}
            <strong>
              35 personas en prisión preventiva vinculados a 25 hechos de
              violencia
            </strong>{' '}
            rural cometidos entre 2018 y 2020. A marzo de este año eran 31 los
            imputados que seguían bajo la misma medida cautelar.{' '}
          </p>

          <p>
            Las usurpaciones violentas también exhibieron un avance en este
            periodo. El werkén de la comunidad Newen Comaco,{' '}
            <strong>Juan Pichunhuala</strong>, lidera un grupo que exige más de
            2.500 hectáreas.{' '}
          </p>

          <p>
            Para esto, dice, cuenta con los títulos de merced. “Nosotros creemos
            firmemente que nuestras tierras fueron usurpadas, entonces el
            gobierno debería ponerse las pilas y que haga su trabajo”, asegura.{' '}
          </p>

          <p>
            Del total de querellas del gobierno,{' '}
            <strong>en más de 140 casos</strong> los ataques ocurrieron en una
            carretera. Uno de los hechos de mayor connotación ocurrió el 21 de
            agosto, en la ruta que une Angol con Collipulli, donde desconocidos
            dispararon contra tres camiones{' '}
            <strong>hiriendo a una niña de 9 años</strong>.{' '}
          </p>

          <p>
            Este año fueron detenidas dos personas que actualmente cumplen pena
            en la cárcel, y otros <strong>34 individuos</strong> tienen la
            calidad de imputados en prisión preventiva.{' '}
          </p>
        </>
      )
      break

    case '2021-1':
      return (
        <>
          <p>
            Considerando solo el primer trimestre del año, el gobierno ha
            presentado <strong>73 querellas</strong> por delitos graves de
            violencia rural, en un inicio de año especialmente crudo: el 7 de
            enero, 850 detectives ingresaron a la comunidad de Temucuicui en un
            operativo antidrogas. Fueron recibidos a balazos, uno de los cuales
            impactó en la cabeza del <strong>inspector Luis Morales</strong>,
            causando su muerte.{' '}
          </p>

          <p>
            La distribución de policías en la zona es un elemento relevante.
            Carabineros, además de patrullar, destina personal para proteger a
            personas amenazadas.{' '}
          </p>

          <p>
            Según sus estadísticas, hasta inicios de mayo cumplían{' '}
            <strong>487 medidas de protección</strong>.{' '}
          </p>

          <p>
            Las custodias policiales que la fiscalía dicta en un año sirven como
            termómetro para conocer la evolución del conflicto. Si en 2018, por
            ejemplo, había 332 resguardos policiales, un año más tarde el número
            se incrementó con fuerza: llegaron a 426 en los siguientes 12 meses
            y a la fecha su número bordea las 500 medidas para evitar atentados.{' '}
          </p>

          <p>
            El análisis de los resultados obtenidos tras las querellas del
            gobierno, muestran la existencia de verdaderas{' '}
            <strong>zonas de impunidad</strong>: comunas donde en los últimos
            cinco años se han cometido hechos graves de violencia donde no
            existen detenidos, según registros del Poder Judicial. Es el caso de
            la comuna de <strong>Tirúa</strong>, donde pese a los 52 ataques de
            alta connotación, no existen formalizados.{' '}
          </p>

          <p>
            Similar situación vive <strong>Contulmo</strong>, que agrupa 30
            ataques y cero formalizados, y <strong>Nueva Imperial</strong>, con
            12 hechos de violencia y ningún arresto.{' '}
          </p>

          <p>
            Cuatro personas que han sido detenidas este año por violencia rural
            cumplen prisión preventiva. Dos son investigados por{' '}
            <strong>dar muerte</strong> a un funcionario de Carabineros.{' '}
          </p>
        </>
      )
      break
    case 'final':
      return (
        <>
          <p>
            Pese a la violencia sostenida que afecta a las regiones del Biobío y
            la Araucanía, las cifras de la PDI indican que desde 2018 a la fecha
            apenas han logrado detener a <strong>14 personas implicadas</strong>{' '}
            en uno de los 477 ataques cometidos desde ese año en la zona.{' '}
          </p>

          <p>
            Desde 2016 a la fecha, en la cárcel existen hoy{' '}
            <strong>50 personas privadas de libertad</strong>, de las cuales 16
            cumplen una condena y otras 34 están sujetas a prisión preventiva.{' '}
          </p>

          <p>
            Las cifras de la fiscalía no son más alentadoras: El Ministerio
            Público de La Araucanía, registra 31 prisiones preventivas en igual
            periodo, donde ocho imputados fueron formalizados por delitos de
            alta connotación. Y la Fiscalía del Biobío, en tanto, solo entregó
            información bajo la <strong>Ley de Transparencia</strong> y decidió
            no hacer comentarios sobre sus escasos resultados. Estas son las
            cifras que ha logrado el Ministerio Público:{' '}
          </p>

          <p className="pb-0 mx-8 mt-8 mb-2 leading-tight text-center font-inter">
            Fiscalía Biobío:
          </p>

          <hr className="mb-4" />

          <ul className="p-2">
            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>314</strong> Investigaciones inició entre 2016 y 2020 la
              Fiscalía del Biobío{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>1%</strong> De sus investigaciones han terminado en
              condena{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>97,4%</strong> De sus investigaciones fueron cerradas sin
              culpables{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>1,6%</strong> De sus investigaciones siguen vigentes{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>2018</strong> Fue el año que más denuncias ingresaron por
              violencia rural (102 casos){' '}
            </li>
          </ul>

          <p className="pb-0 mx-8 mt-8 mb-2 leading-tight text-center font-inter">
            Fiscalía Araucanía:
          </p>

          <hr className="mb-4" />

          <ul>
            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>236</strong> Investigaciones por violencia rural abrió la
              Fiscalía de la Araucanía entre 2018 y 2020{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>1,3%</strong> Del total de causas han tenido condena{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>60,1%</strong> De las investigaciones siguen vigentes{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>38,6%</strong> De las indagatorias están terminadas{' '}
            </li>

            <li className="mb-4 text-2xl leading-tight text-center">
              <strong>2020</strong> Fue el año con mayor cantidad de denuncias
              por violencia rural (119 casos){' '}
            </li>
          </ul>
        </>
      )
      break

    default:
      break
  }
}

export default Textos
